import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import {useTranslation} from "react-i18next";

interface ConfirmModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title?: string;
    body?: React.ReactNode;
    pending?: boolean;
    cancelLabel?: string;
    confirmLabel?: string;
}
export function ConfirmModal(props: ConfirmModalProps) {
    const {t, i18n} = useTranslation();


    return (
        <Modal
            show={props.show}
            onHide={props.pending ? () => undefined : props.onHide}
            backdrop={props.pending ? "static" : true}
            keyboard={!props.pending}
            centered
        >
            <Modal.Header closeButton={!props.pending}>
                <Modal.Title>{props.title || 'Are You Sure?'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.body || 'Do you want to proceed with this action?'}</Modal.Body>
            <Modal.Footer>
                <Button variant="warning" onClick={props.onHide} disabled={props.pending}>
                    {props.cancelLabel || t('main.cancel')}
                </Button>
                <Button variant="primary" onClick={props.onConfirm} disabled={props.pending}>
                    {props.pending && <Spinner animation="border" size="sm" className="me-2" />}
                    {props.confirmLabel || t('main.confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;
